export const DEFAULT_CORRESPONDENCE_TYPES = [
  "In Person",
  "Phone Call",
  "Text Message",
  "Other",
];

export const EXTRA_CORRESPONDENCE_TYPES = [
  "Buddy – Home Visit",
  "Hostel Drop In",
  "Case Study",
];

export default function getCorrespondenceTypes(dropDownData) {
  const base =
    dropDownData && Array.isArray(dropDownData.CorrespondenceType)
      ? dropDownData.CorrespondenceType.filter(Boolean)
      : [];

  const ordered = [
    ...base,
    ...DEFAULT_CORRESPONDENCE_TYPES,
    ...EXTRA_CORRESPONDENCE_TYPES,
  ];

  return ordered.filter((type, index) => ordered.indexOf(type) === index);
}
